<template>
  <transition name="notify">
    <div v-if="visible" class="notification-wrapper">
      <div class="notification-card">
        <!-- Header -->
        <div class="header">
          <div class="header-left">
            <div class="icon">🩺</div>
            <div>
              <p class="title">New Patient Registered</p>
              <p class="subtitle">Patient intake notification</p>
            </div>
          </div>
          <button class="close" @click="close">✕</button>
        </div>

        <!-- Content -->
        <div class="content">
          <div class="item">
            <span class="label">Name</span>
            <span class="value">{{ data.name }}</span>
          </div>

          <div class="item">
            <span class="label">Patient ID</span>
            <span class="pill">{{ data.patient_id }}</span>
          </div>

          <div class="item">
            <span class="label">Gender</span>
            <span class="value">{{ data.gender }}</span>
          </div>

          <div class="item">
            <span class="label">Telephone</span>
            <span class="value">{{ data.telephone }}</span>
          </div>

          <div class="item">
            <span class="label">Address</span>
            <span class="value">{{ data.address }}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "PatientNotification",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      audio: null,
    }
  },
  computed: {
    formattedDate() {
      return new Date(this.data.created_at).toLocaleString()
    },
  },
  mounted() {
    this.audio = new Audio("/sounds/notification.mp3")
    this.show()
  },
  methods: {
    show() {
      this.visible = true
      this.audio?.play().catch(() => {})
      setTimeout(this.close, 12000)
    },
    close() {
      this.visible = false
      this.$emit("close")
    },
  },
}
</script>

<style scoped>
/* Wrapper */
.notification-wrapper {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 9999;
}

/* Card */
.notification-card {
  width: 360px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  border-radius: 18px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  font-family: Inter, system-ui, sans-serif;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #03967d;
  color: #ffffff;
}

.header-left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.icon {
  width: 38px;
  height: 38px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.title {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

.subtitle {
  font-size: 11px;
  opacity: 0.85;
}

.close {
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
}

/* Content */
.content {
  padding: 16px;
}

.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.label {
  font-size: 12px;
  color: #6b7280;
}

.value {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  max-width: 200px;
  text-align: right;
}

.pill {
  background: #dcfce7;
  color: #03967d;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

/* Footer */
.footer {
  margin-top: 14px;
  font-size: 11px;
  color: #9ca3af;
  text-align: right;
}

/* Animations */
.notify-enter-active,
.notify-leave-active {
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.notify-enter-from {
  opacity: 0;
  transform: translateX(120%) scale(0.95);
}

.notify-leave-to {
  opacity: 0;
  transform: translateX(120%) scale(0.95);
}
</style>
